<template>
    <svg version="1.2"
         xmlns="http://www.w3.org/2000/svg"
         xmlns:xlink="http://www.w3.org/1999/xlink"
         overflow="visible"
         preserveAspectRatio="none"
         viewBox="0 0 24 24"
         width="24"
         height="24">
        <g>
            <path xmlns:default="http://www.w3.org/2000/svg" id="smile-o" d="M15.81,13.86c0.07-0.16,0.07-0.34,0-0.5c-0.08-0.18-0.24-0.31-0.43-0.36c-0.16-0.07-0.35-0.07-0.51,0  c-0.16,0.08-0.28,0.23-0.33,0.4c-0.45,1.41-1.95,2.18-3.35,1.74c-0.28-0.09-0.54-0.22-0.77-0.39c-0.47-0.33-0.83-0.8-1-1.35  C9.35,13.04,9,12.8,8.63,12.87c-0.36,0.07-0.6,0.42-0.53,0.79c0.01,0.05,0.02,0.1,0.05,0.14c0.25,0.81,0.75,1.51,1.44,2  c1.41,1.04,3.34,1.04,4.75,0c0.69-0.49,1.19-1.19,1.44-2l0,0L15.81,13.86z M10.28,8.39C9.78,7.85,8.94,7.83,8.4,8.33  c-0.54,0.5-0.56,1.34-0.06,1.88c0.02,0.02,0.04,0.04,0.06,0.06c0.5,0.54,1.34,0.56,1.88,0.06s0.56-1.34,0.06-1.88  C10.32,8.43,10.3,8.41,10.28,8.39z M15.61,8.39c-0.5-0.54-1.34-0.56-1.88-0.06s-0.56,1.34-0.06,1.88c0.02,0.02,0.04,0.04,0.06,0.06  c0.5,0.54,1.34,0.56,1.88,0.06c0.54-0.5,0.56-1.34,0.06-1.88C15.65,8.43,15.63,8.41,15.61,8.39z M18.13,14.58  c-0.67,1.61-1.94,2.88-3.55,3.55c-1.65,0.71-3.52,0.71-5.17,0c-1.61-0.67-2.88-1.94-3.55-3.55c-0.71-1.65-0.71-3.52,0-5.17  c0.67-1.6,1.95-2.88,3.55-3.54c1.65-0.71,3.52-0.71,5.17,0c1.61,0.67,2.88,1.94,3.55,3.55c0.71,1.65,0.71,3.52,0,5.17V14.58z   M18.92,8c-0.7-1.21-1.71-2.22-2.92-2.92C14.79,4.37,13.41,3.99,12,4c-1.41-0.01-2.79,0.37-4,1.08C6.79,5.78,5.78,6.79,5.08,8  C4.37,9.21,3.99,10.59,4,12c-0.01,1.41,0.36,2.79,1.07,4c0.7,1.21,1.71,2.22,2.93,2.92c1.21,0.71,2.59,1.09,4,1.08  c1.41,0.01,2.79-0.36,4-1.07c1.21-0.7,2.22-1.71,2.92-2.93c0.71-1.21,1.09-2.59,1.08-4C20.01,10.59,19.63,9.21,18.92,8z" style="fill: #37a447;" vector-effect="non-scaling-stroke"/>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "GreenSmileySVG"
    }
</script>

<style scoped>

</style>